import { applyFilters, EMPTY_FILTERS, groupRecords, type FilterState } from "./filters";
import type { BootstrapResponse } from "./types";

/**
 * Hook returning grouped records for the active filter state.
 * Spec §3.5: when status is 已固化, records sort by weight desc; otherwise by
 * updatedAt desc then recordId asc.
 */
export function useRecords(filters: FilterState, bootstrap?: BootstrapResponse) {
  const visible = applyFilters(bootstrap?.records ?? [], filters);
  const finalizedOnly = filters.status === "已固化";
  const grouped = groupRecords(
    visible,
    finalizedOnly,
    bootstrap?.feishu_category_options ?? [],
  );
  return {
    grouped,
    totalCount: visible.length,
    finalizedOnly,
    legacyStatusOptions: bootstrap?.status_options ?? [],
    recordStatusOptions: bootstrap?.record_status_options ?? [],
  };
}

export { EMPTY_FILTERS };
